import {Box, Button, Divider, Link, Skeleton, Typography} from '@mui/material';
import axios from 'axios';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useLoaderData, useLocation} from 'react-router-dom';
import HeaderWithIcons from '@components/app/HeaderWithIcons';
import {ICompetition, ICompetitionCategory} from './ICompetitions';
import {appConfig} from '@config';

export default function CompetitionsList() {
	const {t} = useTranslation();
	const location = useLocation();
	const [competitionCategory, setCompetitionCateogry] = useState<ICompetitionCategory | undefined>(location.state);
	let competitions = useLoaderData() as ICompetition[];
	const renderAction = (competition: ICompetition) => {
		let status = <Button component={Link} href={competition.winnerLink} className="mx-3">{t('winner_list')}</Button>;
		switch (competition.status) {
			case 'enabled':
				status = <Button component={Link} href={`/competition/${competition.id}`} className="mx-3">{t('start_competition')}</Button>;
				break;
			case 'remain':
				status = <Typography sx={{color: 'grey.600'}}
				                     className="mx-4">{t('remain_until_start', {day: competition.remainDay})}</Typography>;
		}
		return status;
	};
	return (
		<>
			<HeaderWithIcons title={competitionCategory?.name ?? <Skeleton className="w-24"/>}/>
			<Box className="rounded-sm flex flex-col mx-4 gap-y-2" sx={{
				borderColor: (theme) => theme.palette.mode === 'light' ? 'grey.100' : 'background.paper',
				bgcolor: (theme) => theme.palette.mode === 'light' ? 'secondary.A200' : 'grey.700'
			}}>
				{
					competitions ?
						competitions.map((competition, index) =>
							<Box key={competition.id}>
								<Box sx={{
									bgcolor: (theme) => theme.palette.mode === 'light' ? (competition.status === 'enabled' ? 'secondary.50' : 'grey.50') : (competition.status === 'enabled' ? '#272931' : '')
								}} className="rounded-md flex flex-row items-center h-16">
									<Box
										component="img"
										sx={{
											height: 233,
											width: 350,
											maxHeight: { xs: 65, md: 65 },
											maxWidth: { xs: 65, md: 65 },
										}}
										className="rounded-r-md"
										alt={competition.name}
										src={competition.image}
									/>
									<Typography sx={{color: 'grey.300'}} className="w-8 text-center h-fit">{index + 1}</Typography>
									<Typography
										sx={{color: (theme) => competition.status === 'remain' ? 'grey.400' : (theme.palette.mode === 'light' ? 'grey.800' : 'grey.100')}}
										className="grow h-fit">{competition.name}</Typography>
									{
										renderAction(competition)
									}
								</Box>
								{/*{*/}
								{/*	index + 1 !== competitions.length && <Divider/>*/}
								{/*}*/}
							</Box>)
						:
						''
				}
			</Box>
		</>
	);
}

interface loader {
	request: Request;
	params: {};
}

export async function competitionsListLoader(data: loader) {
	const res = await axios({
		// @ts-ignore
		url: `${appConfig.competition2.url}competitions/${data.params.categoryId}`,
		method: 'GET'
	});
	if (res.data.success) {
		return res.data.result;
	} else {
		return res.data.error;
	}
}
